export let app = angular
	.module('aifs.metaform', [
		'ngResource'
	]);


